import axios from 'axios'

const createInstance = () => {
  return axios.create({
    baseURL: 'https://test-tutor.argong.ai'
    //baseURL: 'http://localhost:3000'
  })
}

const instance = createInstance()

export { instance }
